// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"775429bc","16":"1355a130","23":"c7289c9f","237":"57443b17","453":"b1f1fa64","641":"24813c35","743":"96321fa6","989":"4e1fc61f"}[chunkId] + ".chunk.js";
};